import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const dailySnapshotReportTodo = createAsyncThunk('dailySnapshotReport', async ({ params, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + `reports/daily-snapshot`,
            params: {
                date: params?.date || undefined,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const dailySnapshotReportSlice = createSlice({
    name: 'dailySnapshotReport',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(dailySnapshotReportTodo.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = null
            }
        });
        builder.addCase(dailySnapshotReportTodo.rejected, () => { })
    }
})

export default dailySnapshotReportSlice.reducer;
